import axios from "axios";

const getDevicesControlLogAPI = async groupId => {
  let response = await axios({
    url: `/api/v2/command/task-logs/detail`,
    method: "GET",

    params: {
      task_group_id: groupId
    }
  });
  const devicesControlLogsDetail = response.data.TaskDetail;

  return devicesControlLogsDetail;
};

const getDevicesControlLogTableAPI = async params => {
  let response = await axios({
    url: `/api/v2/command/task-logs/detailTable`,
    method: "GET",
    params
  });
  return response.data;
};

export { getDevicesControlLogTableAPI };

export default getDevicesControlLogAPI;
